import { FormatNumber, LocaleProvider } from "@chakra-ui/react";

export function Number({ value = 0 }){
    return <LocaleProvider locale="de-DE"><FormatNumber value={value / 100} /></LocaleProvider>
}

export function Amount({ value = 0 }){
    return <FormatNumber value={value / 100} style="currency" currency="BRL" />
}